export default "__VITE_ASSET__DZ3u7LC9__"